export default {
  TITLE: '个人信息收集清单',
  CONTENT: `
    <h3>基本信息</h3>
    <ul>
      <li>识别信息，如您的姓名、地址和电话号码；</li>
      <li>支付信息；</li>
      <li>地址中列出的姓名、地址和电话号码；</li>
      <li>给我们的评论内容；</li>
      <li>您的公开资料中的自我介绍或照片；</li>
      <li>关于身份的信息和文件，包括身份证号码；</li>
    </ul>
    <h3>交易信息</h3>
    <ul>
      <li>我的订单：在您完成订单及订单管理时采集，用于交易履约</li>
      <li>购物车在您添加和管理购物车时采集，用于交易履约</li>
      <li>足迹：在您浏览商品与服务时采集，用于更好的展现商品与服务</li>
      <li>搜索记录：在您搜索商品与服务时采集，用于更好的展现商品与服务</li>
    </ul>
    <h3>设备信息</h3>
    <ul>
      <li>
        设备信息：为向您提供适配的页面展示、保障账号及交易安全、个性化推荐服务，我们将在帮您启动APP或者下单时，收集使用您的设备型号及其他设备信息。
      </li>
    </ul>
  `
};
